import React from "react";
import { Trash } from "./../../../../assets/images/svg";
import { Info } from "./Info";

export const ReferralCategoryRow = ({
  item,
  referralId,
  handleReferralCategory,
  canUnassignAll,
  canUnassign,
  canShow,
  setSelectedReferral
}) => {
  const { id, name, keywordsCount, clientsCount } = item;
  const keywordText = `${keywordsCount} keyword${keywordsCount != 1 ? "s" : ""}`;
  const clientsText = `${clientsCount} client${clientsCount != 1 ? "s" : ""}`;

  return (
    <>
      <li
        color="dark"
        className={`group__item ${!canShow ? "group__item--no-pointer" : ""}`}
        onClick={() => handleReferralCategory(id, keywordsCount, clientsCount)}
      >
        <div className="group__el text">
          {name} ({keywordText}, {clientsText})
        </div>
        {canUnassignAll && (keywordsCount || clientsCount) ? (
          <div className="group__el delete">
            <span
              className="group__icon"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedReferral({ id, name });
              }}
              title="Delete"
            >
              <Trash color="#FF0000" />
            </span>
          </div>
        ) : null}
      </li>
      {id === referralId ? <Info referralCategoryId={id} canUnassign={canUnassign} /> : null}
    </>
  );
};
